// HomePage.jsx
import React from 'react';
import Head from 'next/head';  // Replace react-helmet with Next.js Head
import BaseLayout from '../layouts/BaseLayout.jsx';
import MatterScene from '../components/MatterScene2';
import IconCollections from '../components/CollectionBanners2.jsx';
import FAQ from '../components/FAQ.jsx';


const HomePage = () => {
  return (
    <>
      {/* Next.js Head for canonical URL */}
      <Head>
        <link rel="canonical" href="https://davooda.com" />
      </Head>
      
      <BaseLayout
        title="Davooda's Icons Shop."
        description="Beautiful Icons for web-design, application, design and more."
        showHeader={true}
      >
        <div>
         
          <IconCollections />
          <MatterScene />
          {/* <FAQ /> */}
        </div>
      </BaseLayout>
    </>
  );
};

export default HomePage;